(function($) {

    var subscriptionFormValid = true;
    var subscriptionFormSubmit = $('.subscription-form-submit');
    var subscriptionRequiredFields = $('.subscription-form-wrap .required');

    function matchStart(params, data) {
        params.term = params.term || '';
        if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
            return data;
        }
        return false;
    }

    $(document).ready(function() {
        $('.subscription-dropdown').select2({
            width: 'auto',
            // minimumResultsForSearch: -1,
            placeholder: $(this).data('placeholder'),
            language: {
                noResults: function () {
                    return "Rezultatų nerasta";
                }
            },
            matcher: function(params, data) {
                return matchStart(params, data);
            }
        });


    });

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    subscriptionFormSubmit.on('click', function () {

        subscriptionFormSubmit.addClass('loading');

        subscriptionFormValid = true;
        $('.subscription-form-wrap .input-wrap').removeClass('has-error');
        $('.subscription-form-wrap .input-wrap .input-error').hide();

        subscriptionRequiredFields.each(function (ind, el) {

            if ($(el).attr('name') === 'subscription-email') {
                if ($(el).val() === '') {
                    subscriptionFormValid = false;
                    $(el).parent().addClass('has-error').find('.input-error.subscription-email-required').show();
                } else if (!validateEmail($(el).val())) {
                    subscriptionFormValid = false;
                    $(el).parent().addClass('has-error').find('.input-error.subscription-email-incorrect').show();
                }
            } else {
                if ($(el).val() === '') {
                    subscriptionFormValid = false;
                    $(el).parent().addClass('has-error').find('.input-error').show();
                }
            }
        });

        if (subscriptionFormValid) {

            var data = {
                'action' : 'submit_subscriber',
                'email' : $('[name=subscription-email]').val(),
                'district' : $('[name=subscription-location]').val(),
            };

            $.get(postmpwp.ajax_url, data, function(response){

                subscriptionFormSubmit.removeClass('loading');

                if (response.success) {
                    $('.subscription-form-wrap').hide();
                    $('.subscription-form-success').show();
                } else {
                    $('.subscription-email-exists').show().parent('').addClass('has-error');
                }
            });

        } else {
            subscriptionFormSubmit.removeClass('loading');

            $('html, body').animate({scrollTop: $('body').find('.has-error').offset().top - 200}, 400);
        }
    });

})( jQuery );